import { SessionAnalysis } from "../types/supabase";
import { BaseApi } from "./baseApi";

export const sessionAnalysisApi = new BaseApi<SessionAnalysis>(
  "session_analysis"
);
